import { type EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import { type HousingUnit } from '@reliance/types/models/HousingUnit';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService, type QueryParams } from '../types/ApiService';

export const housingUnit = (centralApi: ApiService) => ({
  index: (
    params: QueryParams = {},
  ): Promise<PaginatedResponse<HousingUnit>> => {
    return centralApi.get('/housing-unit', { params });
  },
  putAudioCallEnabled: (id: number, enabled: boolean): Promise<void> => {
    return centralApi.put(`/housing-unit/${id}`, {
      audioCallingEnabled: enabled,
    });
  },
  putVideoCallEnabled: (id: number, enabled: boolean): Promise<void> => {
    return centralApi.put(`/housing-unit/${id}`, {
      videoCallingEnabled: enabled,
    });
  },
  putTextingEnabled: (id: number, enabled: boolean): Promise<void> => {
    return centralApi.put(`/housing-unit/${id}`, { textingEnabled: enabled });
  },
  putCommunicationsEnabled: (id: number, enabled: boolean): Promise<void> => {
    return centralApi.put(`/housing-unit/${id}`, {
      communicationsEnabled: enabled,
    });
  },
  putReferenceMaterialEnabled: (
    id: number,
    enabled: EnabledDisabled,
  ): Promise<void> => {
    return centralApi.put(`/housing-unit/${id}`, {
      referenceMaterialEnabled: enabled,
    });
  },
  putGamesEnabled: (id: number, enabled: EnabledDisabled): Promise<void> => {
    return centralApi.put(`/housing-unit/${id}`, { gamesEnabled: enabled });
  },
  putMusicEnabled: (id: number, enabled: EnabledDisabled): Promise<void> => {
    return centralApi.put(`/housing-unit/${id}`, { musicEnabled: enabled });
  },
});
